import React, { createRef, Component } from "react";
import _ from 'lodash'
import {
  Map,
  WMSTileLayer,
  ScaleControl,
  Marker,
  GeoJSON,
  Pane,
} from "react-leaflet";
import { Button, Message, Icon, Popup, Menu } from "semantic-ui-react";
import L from "leaflet";
import Control from "react-leaflet-control";
// import axios from 'axios';
import moment from "moment";
import { renderToStaticMarkup } from 'react-dom/server';

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExpand,
  faWindowClose,
  faChartBar,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList,
} from "@fortawesome/free-solid-svg-icons";
import GraphOptionsBox from './GraphOptionsBox';
//import GraphOptionsBox1 from './GraphOptionsBox1';
import MouseControl from "../../MousePosition";
import domain from "../../domain";
import { isNull } from "util";
import DateSlider from "./DateSlider";
import colors from "../../colors";
import urls from "../../urls";
import layerMap from "../Helpers/layer-map";
import ReactHTMLParser from "react-html-parser";

import Axios from "axios";
import { FadeLoader } from "react-spinners";
import * as helpers from "../../helpers";
import reservoir_icon from '../assets/reservoir_inflow3.png'
import { OffCanvas, OffCanvasMenu } from "react-offcanvas";
// import ReactHTMLParser from 'react-html-parser';

library.add(
  faWindowClose,
  faChartBar,
  faExpand,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList
);

// import Grid9minView from './Grid9minView'
// import DrawPolygon from './DrawPolygon'
// wrap `Dialog` component with `withLeaflet` HOC
let count = 0;
let count1 = 0;

const crs = L.CRS.EPSG4326;
// var theMarker = {};

// const subRoutes = [

//     {
//       path: "/webgis-vic/map/hydrological-science",
//        component: (props) => <InformationOverlay {...props} />,

//     },

//   ];

const platformItems = [
  {
    name: 'about',
    tooltip: 'On',
    className: 'fa fa-info about',
  },
  {
    name: 'download',
    tooltip: 'Download',
    className: 'fa fa-download download',
  },
  // {
  //     name: 'share',
  //     tooltip: 'To Share',
  //     className: 'fa fa-share-alt share',
  // },
  // {
  //     name: 'draw',
  //     tooltip: 'To Draw',
  //     className: 'fa fa-pencil draw',
  // },
  // {
  //     name: 'polygonRequest',
  //     tooltip: 'Search by Design',
  //     className: 'fa fa-pencil-square-o polygonRequest',
  // },
  {
    name: 'search',
    tooltip: 'Area filtering',
    className: 'fa fa-search search',
  },
  {
    name: 'login',
    tooltip: 'Login',
    className: 'fa fa-sign-in login login-logout',
  },
  {
    name: 'help',
    tooltip: 'Help',
    className: 'fa fa-question help',
  },
]
const mapItems = [
  {
    name: 'basemaps',
    tooltip: 'Bottom Layers',
    className: 'fa fa-map basemaps',
  },

]
const style = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};
function isDateInArray(needle, haystack) {
  for (var i = 0; i < haystack.length; i++) {
    if (needle.getTime() === haystack[i].getTime()) {
      return true;
    }
  }
  return false;
}

// function capital_letter(str)
// {
//     str = str.split(" ");

//     for (var i = 0, x = str.length; i < x; i++) {
//         str[i] = str[i][0].toUpperCase() + str[i].substr(1);
//     }

//     return str.join(" ");
// }
class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smai_leg: "<br/>W22: 28<sup>th</sup> May  – 03<sup>rd</sup> June<br />W23: 04<sup>th</sup> June – 10<sup>th</sup> June<br />W24: 11<sup>th</sup> June – 17<sup>th</sup> June<br />W25: 18<sup>th</sup> June – 24<sup>th</sup> June<br />W26: 25<sup>th</sup> June – 01<sup>st</sup> July<br />W27: 02<sup>nd</sup> July – 08<sup>th</sup> July<br />W28: 09<sup>th</sup> July – 15<sup>th</sup> July<br />W29: 16<sup>th</sup> July – 22<sup>nd</sup> July<br />W30: 23<sup>rd</sup> July – 29<sup>th</sup> July<br />W31: 30<sup>th</sup> July – 05<sup>th</sup> Aug <br />W32: 06<sup>th</sup> Aug  – 12<sup>th</sup> Aug <br />W33: 13<sup>th</sup> Aug  – 19<sup>th</sup> Aug <br />W34: 20<sup>th</sup> Aug  – 26<sup>th</sup> Aug <br />W35: 27<sup>th</sup> Aug  – 02<sup>nd</sup> Sept<br />W36: 03<sup>rd</sup> Sept – 09<sup>th</sup> Sept<br />W37: 10<sup>th</sup> Sept – 16<sup>th</sup> Sept<br />W38: 17<sup>th</sup> Sept – 23<sup>rd</sup> Sept<br />W39: 24<sup>th</sup> Sept – 30<sup>th</sup> Sept<br />W40: 01<sup>st</sup> Oct  – 07<sup>th</sup> Oct <br />W41: 08<sup>th</sup> Oct  – 14<sup>th</sup> Oct <br />W42: 15<sup>th</sup> Oct  – 21<sup>st</sup> Oct <br />W43: 22<sup>nd</sup> Oct  – 28<sup>th</sup> Oct <br />W44: 29<sup>th</sup> Oct  – 04<sup>th</sup> Nov <br />W45: 05<sup>th</sup> Nov  – 11<sup>th</sup> Nov <br />W46: 12<sup>th</sup> Nov  – 18<sup>th</sup> Nov <br />W47: 19<sup>th</sup> Nov  – 25<sup>th</sup> Nov <br />W48: 26<sup>th</sup> Nov  – 02<sup>nd</sup> Dec <br />W49: 03<sup>rd</sup> Dec  – 09<sup>th</sup> Dec <br />W50: 10<sup>th</sup> Dec  – 16<sup>th</sup> Dec <br />W51: 17<sup>th</sup> Dec  – 23<sup>rd</sup> Dec <br />W52: 24<sup>th</sup> Dec  – 31<sup>st</sup> Dec <br />",
      width: 420,
      height: 300,
      x: 0,
      y: 100,
      minZoom: 3,
      maxZoom: 15,
      zoom: window.innerWidth > 1000 ? 4 : 3,
      center: window.innerWidth > 1000 ? [22.12539, 79.00164] : [20.13, 80.58],
      isMenuOpened: true,
      pointInfo: null,
      // wms_url:'http://192.168.192.103:8080/geoserver/evapotranspiration/wms',
      // wms_url_default:`${domain.Geoserver}geoserver/evapotranspiration/wms`,
      legend: null,
      legendVisible: true,
      visibleRight: false,
      isExpand: false,
      setGraph: false,
     
      
      

      basininfo: null,
      chartloading_reservoir: false,
      chartData_reservoir: null,
      markerenable: true,
      layers:
        props.selected !== "Inflows into major reservoirs"
          ? urls.map_layer
          : "nhp_snowcomponent:Basins",
      url:
        props.selected !== "Inflows into major reservoirs"
          ? urls.bhuvan_map
          : `${domain.Geoserver}/nhp/snowcomponent`,

      baseLayers: false,
      baselayerselected:
        props.selected !== "Inflows into major reservoirs" ? "Map" : "Basin",
      // onClickDetails:{},
      // highlightState:null
      // selected:this.props.selected
    };
  }
  mapRef = createRef();
  tileRef = createRef();

  resetZoom = () => {
    const leafletMap = this.mapRef.current.leafletElement;
    leafletMap.setZoom(this.state.zoom);
    leafletMap.panTo(new L.LatLng(25.12539, 80.00164));
  };

  onMouseOver = async (e) => {
    // const map = this.mapRef.current.leafletElement

    let result = helpers.check_boundary(e.latlng.lat, e.latlng.lng);
    if (result === true) {
      // this.setState({
      //     latlng:e.latlng
      //     // latlng:{lat: L.Projection.LonLat.project(e.latlng).y, lng:L.Projection.LonLat.project(e.latlng).x}
      //     // showInfo:true,
      // })
      console.log(e);
      // this.props.setLatLng({lat: L.Projection.LonLat.project(e.latlng).y, lng:L.Projection.LonLat.project(e.latlng).x})
      this.props.setLatLng(e.latlng);
      let result = await Axios({
        method: "post",
        url: `${domain.DBServer}/get-pixel-boundary-status`,
        data: {
          lon: e.latlng.lng,
          lat: e.latlng.lat
          // selected: this.state.selectedMenu
        }
      });
      if (result) {
        if (result.data[0].bounds) {
          console.log("vvvvvvvvvvvvvvvvvvvvvv",layerMap[this.props.selected], layerMap[this.props.selected].split("_")[0])
         // layerMap[this.state.selectedMenu].split("_")[0] !== "FSRO"
          if (layerMap[this.props.selected] !== 'SMAI' &&  layerMap[this.props.selected].split("_")[0] !== 'FSRO' )

            console.log("vvvvvvvvvvvvvvvvvvvvvv1",layerMap[this.props.selected], layerMap[this.props.selected].split("_")[0])

            this.props.makeChartDataAvailableDays();
          if (this.props.selected !== null  &&  layerMap[this.props.selected].split("_")[0] !== 'FSRO') {
            console.log("vvvvvvvvvvvvvvvvvvvvvv2",layerMap[this.props.selected], layerMap[this.props.selected].split("_")[0])

            this.props.handleVisibleGraphPanelOnMapClick();
          }
          if (layerMap[this.props.selected] !== 'SMAI' &&  layerMap[this.props.selected].split("_")[0] !== 'FSRO')
            console.log("vvvvvvvvvvvvvvvvvvvvvv3",layerMap[this.props.selected], layerMap[this.props.selected].split("_")[0])

            this.props.makeChartDataAvailableDays();
          // if(this.props.selected!==null){

          //     this.props.handleVisibleGraphPanelOnMapClick()
          // }

          if (!this.props.noGraph[this.props.selected] &&  layerMap[this.props.selected].split("_")[0] !== 'FSRO') {
            console.log("vvvvvvvvvvvvvvvvvvvvvv4",layerMap[this.props.selected], layerMap[this.props.selected].split("_")[0])

            this.props.handleVisibleGraphPanelOnMapClick();
          } else {
            if ( layerMap[this.props.selected].split("_")[0] !== 'FSRO') {
            console.log("vvvvvvvvvvvvvvvvvvvvvv5",layerMap[this.props.selected], layerMap[this.props.selected].split("_")[0])

            this.props.handleVisibleGraphPanelOnMapClick_NoGraph();

            this.props.showInfoOnMapClick();
            }
            
          }
        } else {
          this.setState({
            markerenable: false,
          });
        }
//--------------------------------------------original-----------------------------------------
        // if (result.data[0].bounds) {
        //   console.log(layerMap[this.props.selected])
        //   if (layerMap[this.props.selected] !== 'SMAI')
        //     this.props.makeChartDataAvailableDays();
        //   if (this.props.selected !== null) {
        //     this.props.handleVisibleGraphPanelOnMapClick();
        //   }
        //   if (layerMap[this.props.selected] !== 'SMAI')
        //     this.props.makeChartDataAvailableDays();
        //   // if(this.props.selected!==null){

        //   //     this.props.handleVisibleGraphPanelOnMapClick()
        //   // }

        //   if (!this.props.noGraph[this.props.selected]) {
        //     this.props.handleVisibleGraphPanelOnMapClick();
        //   } else {
        //     this.props.handleVisibleGraphPanelOnMapClick_NoGraph();
        //     this.props.showInfoOnMapClick();
        //   }
        // } else {
        //   this.setState({
        //     markerenable: false,
        //   });
        // }

      //------------------------------------------------------


        
      }
      else { return }
    }
    //e.latlng.lat, e.latlng.lng

  };

  handlePopupClose = () => {
    this.props.setPopupMenuSelectedStatus();
    this.props.togglePopupMenuSelected(this.props.popupMenuSelectedLast);
  };

  componentDidUpdate(prevProps, PrevState) {
    // console.log(this.props.selected,prevProps.selected)
    // if(this.props.selected!==prevProps.selected){
    if (this.props.selectedLayer !== prevProps.selectedLayer) {
      console.log(123)
      console.log(123)
      console.log(this.props)

      let layer =
        this.props.selected !== null && this.props.selected !== 'smai-weekly' && this.props.selected !== 'smai-monthly'
          ? "VIC:" +
          layerMap[this.props.selected] +
          "_" +
          this.props.selectedLayer[this.props.selected]
          : this.props.selected === 'smai-weekly' ? "VIC:" + this.props.selectedLayer[this.props.selected] 
          : this.props.selected === 'smai-monthly' ? "VIC:" + this.props.selectedLayer[this.props.selected] : null
          // : this.props.selected === 'smai-weekly' ? "VIC:" + 'SMAI_' + this.props.weekyearselected + "_" + this.props.weekselected 
          // : this.props.selected === 'smai-monthly' ? "VIC:" + "SMAI_Y" + this.props.monthyearselected + "_" + this.props.monthselected : null

          console.log(123)
          console.log(123)
          console.log(layer)

      let wms_url =
        this.props.selected !== null ? `${domain.Geoserver}/nhp_vic/wms` : null;

      const colors_range = [
        "#FFFFFF",
        "#00f783",
        "#00d891",
        "#00c49b",
        "#00a8a9",
        "#008db7",
        "#0075c4",
        "#005ece",
        "#0046db",
        "#002de7",
        "#000ad5",
      ];
      const grades = [
        " 0-1",
        " 1-10",
        " 10-20",
        " 20-30",
        " 30-40",
        " 40-50",
        " 50-60",
        " 60-70",
        " 80-90",
        " >90",
      ];



      const colors_range_et = [
        "#ff0000",
        "#ff6200",
        "#ff9d00",


        "#ffff00",
        "#f4ff2b",
        "#cdff70",
        "#99ffad",
        "#4affea",
        "#2ed2ff",

        "#3b90ff",

        "#3355ff",
        "#0000ff"


      ];
      const grades_et = [
        " 0 - 0.1 ",
        " 0.1 - 0.5",
        " 0.5 - 1",
        " 1- 2",
        " 2 - 3",
        " 3 - 4 ",
        " 4 - 5",
        " 5 - 6 ",
        " 6 - 7 ",
        " 7 - 8 ",
        " 8  - 9 ",
        " 9  - 10 ",

      ];
      const sfro_colors = [
        "#00f783",
        "#00d891",
        "#00c49b",
        "#00a8a9",
        "#008db7",
        "#0075c4",
        "#005ece",
        "#0046db",
        "#002de7",
        "#000ad5",
      ];
      const sfro_range = [
        " 0-10",
        " 10-20",
        " 20-30",
        " 30-40",
        " 40-50",
        " 50-60",
        " 60-70",
        " 80-90",
        " >90",
      ];

      let img = grades.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${colors_range[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      let img_et = grades_et.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${colors_range_et[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      let img_sfro = sfro_range.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${sfro_colors[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      this.getLegendGraphic(wms_url, layer).then((legend) => {
        console.log(legend);
        this.props.setLegend(legend);
      });

    }

    if (this.props.visibleLeft === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    if (this.props.visibleGraphPanel === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    if (this.props.geojsondata !== prevProps.geojsondata) {

    }
  }

  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 30;
    let height = 20;

    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&legend_options=dpi:80`;
   console.log(img_src)
    return img_src;
  }

  handleMark = () => {
    this.setState({ markerenable: true });
  };
  handleAnimationChangeRight = () => {
    this.setState({
      visibleRight: !this.state.visibleRight,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };
  handleExpand = () => {
    this.setState({
      isExpand: !this.state.isExpand,
    });
  };
  highlightBasin = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    layer.setStyle({
      weight: 2,
      fill: false,
      color: "#0000ff",
      fillOpacity: 0,
    });
    console.log(map);
    map.fitBounds(layer.getBounds());
  };
  highlightState = (feature, layer) => {
    // const map = this.mapRef.current.leafletElement
    const map = this.mapRef.current.leafletElement;
    layer.setStyle({
      weight: 2,
      color: "#000000",
      fillOpacity: 0,
      // fill:false
    });

    layer.on({
      mouseover: (event) => {
        layer.setStyle({
          weight: 3,
          color: "#0000ff",
          fillOpacity: 0,
          //  fill:false
        });
      },
      mouseout: (event) => {
        layer.setStyle({
          weight: 3,
          color: "#000000",
          fillOpacity: 0,
          //  fill:false
        });
      },
    });
    console.log(this.props.selected)
    layer.on({
      click: this.openPopupWeekly
    });
    //   let string = feature.properties.state!==null?feature.properties.state:""
    // let  label = L.marker(layer.getBounds().getCenter(), {
    //     icon: L.divIcon({
    //       className: "label",
    //       html: `<h5>${string}</h5>`,
    //       iconSize: [20, 20],
    //     }),
    //   }).addTo(map);
  };

  openPopupWeekly = (e) => {
    if (layerMap[this.props.selected] === 'SMAI') {
      console.log("Test123"+ this.props.selected)
      console.log("Test12"+ layerMap[this.props.selected])
      if(this.props.selected === 'smai-weekly') {
        if (e.target.feature.properties) {
          let value = e.target.feature.properties.state
          console.log(value)
          Axios.get(`${domain.DBServer}/get-smai-weekly-state/${value}/${this.props.weekyearselected}`).then((result) => {
            if (result) {
              if (result.data) {
                console.log(result.data)
                this.props.setWeeklyData(result.data,value)
              }
            }
          })
        }
      } else {
        if (e.target.feature.properties) {
          let value = e.target.feature.properties.state
          console.log(value)
          Axios.get(`${domain.DBServer}/get-smai-monthly-state/${value}/${this.props.monthyearselected}`).then((result) => {
            if (result) {
              if (result.data) {
                console.log(result.data)
                this.props.setMonthlyData(result.data,value)
              }
            }
          })
        }
      } 
    }
  }

  addPopup = (e) => {
    console.log(e.target.feature.properties);
    console.log(this.props.selected.split("-")[1])
    this.props.emptyChartData()
    let value = e.target.feature.properties.BASINCWC;
    Axios.get(`${domain.DBServer}/get-indian-basin/${value}`).then((result) => {
      if (result) {
        if (result.data) {
          this.setState({
            basininfo: result.data[0].basin_boundary,
          });
          count1 = count1 + 1;
        }
      }
    });
    console.log(e.target.feature.properties.Res_ID);
    this.setState({
      chartloading_reservoir:true,
    })
    this.props.setloading_fun("true")


    Axios.get(
      `${domain.DBServer}/get-vic-inflow-major-reservoir-data-flow/${e.target.feature.properties.Res_ID}/${this.props.selected.split("-")[1]}`
    ).then((result) => {
      let chartData,
       dates_hist=[],
       flow_hist=[],
      month_monthlyAvg:[],
      flow_monthlyAvg:[],
      month_dailyAvg:[],
      flow_dailyAvg:[],
      dates_dailyAvg:[],
      prob_flowDur:[],
      flow_flowDur:[],
      year_returnPer:[],
      flow_returnPer:[];
      
      if (result) {
        if (result.data.data1) {
          console.log(result.data.data1);
          let a = result.data.data1
          let resArr = []
          result.data.data1.filter(function (item) {
            var i = resArr.findIndex(x => (x.dates == item.dates));
            if (i <= -1)
              resArr.push(item);
          });
          console.log("RRRRRRRRRRRRRRRRRRRRRRR",resArr)
          chartData = resArr.map((result) => {
            let chartDate = moment(result.dates);
            return [
              Date.UTC(
                parseInt(chartDate.format("YYYY"), 10),
                parseInt(chartDate.format("MM"), 10) - 1,
                parseInt(chartDate.format("DD"), 10)
              ),
              this.props.selected.split("-")[1] === 'tc' ? Number(result.tc).toFixed(3) : this.props.selected.split("-")[1] === 'ic' ? Number(result.ic).toFixed(3) : Number(result.tuc).toFixed(3),
            ];
          });
          //    inflows=result.data.map((result)=>{
          //        return(result.inflow)
          //    })
        }
      }
      console.log("ccccchartdata",chartData)


      var dates_mod = chartData.map(function (x) {
        return new Date(x[0]);
      });
      console.log(dates_mod.length);
      let maximumdate = new Date(Math.max.apply(null, dates_mod));
      let curr_date = maximumdate.setDate(maximumdate.getDate() - 2);
      let position = e.latlng;
      let name = e.target.feature.properties.name;
      let date = curr_date;

      if(result.data.data2){
       
        dates_hist=result.data.data2.map((result)=>{
                 return(result.dates)

      });
      flow_hist=result.data.data2.map((result)=>{
        return(result.flow)

        });

console.log(flow_hist,"//////////hist///////////",dates_hist)


      }

      
      if(result.data.data3){
       
        month_monthlyAvg=result.data.data3.map((result)=>{
                 return(result.month)

      });
      flow_monthlyAvg=result.data.data3.map((result)=>{
        return(result.flow)

        });

console.log(flow_monthlyAvg,"///////////////month////////",month_monthlyAvg)


      }

      if(result.data.data4){
       
        month_dailyAvg=result.data.data4.map((result)=>{
                 return(result.month)

      });
      flow_dailyAvg=result.data.data4.map((result)=>{
        return(result.flow)

        });
        dates_dailyAvg=result.data.data4.map((result)=>{
          return(result.date)
  
          });

console.log(flow_dailyAvg,"///////////////daily////////",month_dailyAvg,dates_dailyAvg)


      }

      if(result.data.data5){
       
        prob_flowDur=result.data.data5.map((result)=>{
                 return(Number(result.probability))

      });
      flow_flowDur=result.data.data5.map((result)=>{
        return(result.flow)

        });

console.log(flow_flowDur,"///////////////flow///////",prob_flowDur)


      }

      if(result.data.data6){
       
        year_returnPer=result.data.data6.map((result)=>{
                 return(result.year)

      });
      flow_returnPer=result.data.data6.map((result)=>{
        return(Number(result.flow))

        });

console.log(flow_returnPer,"///////////////return///////",year_returnPer)

      }


      this.props.toggleVisibleGraphPanel_pie();

      console.log(position,"*************************************", name,"*************************************", date,"*************************************", chartData,"*************************************",)
      this.props.setGradientContent(position, name, date, chartData,dates_hist,flow_hist,month_monthlyAvg,flow_monthlyAvg,dates_dailyAvg,flow_dailyAvg,month_dailyAvg,prob_flowDur,flow_flowDur,year_returnPer,flow_returnPer);
    });
  };


  onEachFeature = (feature, layer) => {
    console.log(feature);
    let popupContent =
      "<table class='table table-bordered table-sm'>" +
      "<thead class='bg-primary text-white'><tr><th class='text-center '>Reservoir Name</th><th class='text-center'>Basin</th>" +
      "</tr></thead><tbody><tr><td><b color='blue'>" +
      feature.properties.name +
      "</b></td><td> <b color='blue'> " +
      feature.properties.Basin + '</td></tr></tbody></table>';
    // var customOptions =
    // {
    // 'maxWidth': '400',
    // 'width': '200',
    // 'className' : 'popupCustom'
    // }
    layer.bindPopup(popupContent);

    layer.on({
      mouseover: (e) => {
        layer.openPopup();
      },
      mouseout: (e) => {
        layer.closePopup();
      },

      click: this.addPopup,
    });
  };
  // mouseover=(event)=>{
  //     console.log(event.target)
  // }
  pointToLayer = (feature, latlng) => {
    // const iconMarkup = renderToStaticMarkup(<i className=" fa fa-map-marker-alt fa-3x" />);
    // const customMarkerIcon = L.divIcon({
    //   html: iconMarkup,
    // });

    var icon = L.icon({
      iconUrl: reservoir_icon,
      iconSize: [35, 50]
    });

    return L.marker(latlng, { icon: icon });
  };

  loading = (e) => {
    this.setState({
      layerloading: true,
    });
    // console.log(e)
  };
  load = (e) => {
    this.setState({
      layerloading: false,
    });
  };
  displayBaseLayers = () => {
    console.log("base layers");
    this.setState({
      baseLayers: !this.state.baseLayers,
    });
  };
  changeBaseLayer = (event) => {
    let layers, url;
    //  this.findActiveLayers()
    console.log(event.target);
    if (event.target.value === "Map") {
      url = urls.bhuvan_map;
      layers = urls.map_layer;
    } else if (event.target.value === "Satellite") {
      layers = urls.s_layer;
      // url='http://192.168.192.103:8080/geoserver/cite/wms'
      url = urls.satellite;
    } else if (event.target.value === "Basin") {
      layers = "nhp_snowcomponent:basins";
      // url='http://192.168.192.103:8080/geoserver/cite/wms'
      url = `${domain.Geoserver}/nhp_snowcomponent/wms`;
    }

    this.setState({
      baselayerselected: event.target.value,
      url: url,
      layers: layers,
    });
  };
  handleClick_tools = (value) => {
    if (value === 'about') {
      this.setState({
        informationVisible: true
      })
      // this.props.handleChangeHelp(true)
    }
  }
  render() {
    let title;
    console.log("graphicalvic",this.props.visibleGraphPanel ,this.props.r_chartdata );
    var reservoir_status = 0
    delete L.Icon.Default.prototype._getIconUrl;
    console.log("this.props.selected",this.props.selected,"...................",layerMap[this.props.selected],this.props.pointInfo)

    // console.log((this.props.visibleGraphPanel && this.props.noGraph[this.props.popMenuSelected])===true)
    //    console.log(!(this.props.visibleGraphPanel && this.props.noGraph[this.props.popMenuSelected]))
    if (this.props.selected !== null) {
      if (this.props.selected.includes('Inflows into major reservoirs') || layerMap[this.props.selected] === 'SMAI') {
        reservoir_status = 1
      }
      else {
        reservoir_status = 0
      }
    }
    console.log(layerMap[this.props.selected])
    console.log(this.props.india_states_boundary);
    if (this.props.reservoirjson) {
      count = count + 1;
    }
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
    // console.log("VIC:"+layerMap[this.props.selected]+"_"+this.props.selectedLayer[this.props.selected])
    if (layerMap[this.props.selected]) {
      let t = layerMap[this.props.selected];
      console.log(t);
      if (t.split("_")[0] === "RF") {
        title = "IMD Rainfall (mm) <br/> ";
      } else if (t.split("_")[0] === "RO") {
        title = "Runoff (mm) <br/> ";
      } else if (t.split("_")[0] === "ET") {
        title = "Actual Evapotranspiration<br/> (mm) <br/> ";
      } else if (t.split("_")[0] === "RSM") {
        title =
          "Root Zone Soil Moisture (0-50cm) <br/>(m<sup>3</sup>/m<sup>3</sup>) <br/>";
      } else if (t.split("_")[0] === "USM") {
        title = "Upper Soil Moisture (0-15cm)<br/>(m<sup>3</sup>/m<sup>3</sup>) <br/> ";
      } else if (t.split("_")[0] === "LSM") {
        title = "Lower Soil Moisture (15-50cm)<br/>(m<sup>3</sup>/m<sup>3</sup>) <br/> ";
      } else if (t.split("_")[0] === "DSM") {
        title = "Deep Soil Moisture (50-150cm)<br/>(m<sup>3</sup>/m<sup>3</sup>) <br/> ";
      } else if (t.split("_")[0] === "FSRO" && t.split("_")[1] === "1") {
        let d = moment(this.props.activeDate).add(0, "days").format("LL");
        console.log(d);
        title = `Forecast Surface Runoff <br/> (mm) <br/> Actual Date ${d} <br/> Estimated Date:`;
      } else if (t.split("_")[0] === "FSRO" && t.split("_")[1] === "2") {
        let d = moment(this.props.activeDate).add(1, "days").format("LL");
        console.log(d);
        title = `Forecast Surface Runoff <br/>(mm) <br/> Actual Date: ${d} <br/> Estimated Date:`;
      } else if (t.split("_")[0] === "FSRO" && t.split("_")[1] === "3") {
        let d = moment(this.props.activeDate).add(2, "days").format("LL");
        console.log(d);
        title = `Forecast Surface Runoff <br/> (mm) <br/> Actual Date: ${d} <br/> Estimated Date:`;
      }
      else if(t==='SMAI')
      {
        if(this.props.selected === 'smai-weekly') {
          title=`SMAI (%) -${this.props.weekyearselected} - ${this.props.weekselected}`
        } else {
          title=`SMAI (%) -${this.props.monthyearselected} - ${this.props.monthselected}`
        }
      }
    }

    console.log(this.props.selectedMenu);
    return (
      <Map
        ref={this.mapRef}
        // ref={m => { this.leafletMap = m }}
        center={this.state.center}
        minZoom={this.state.minZoom}
        maxZoom={this.state.maxZoom}
        zoom={this.state.zoom}
        onClick={reservoir_status !== 1 ? this.onMouseOver : null}
        // onlayeradd={this.onLayer}
        style={{ backgroundColor: "#fff" }}
        attributionControl={false}
        crs={crs}
        dragging={true}
      // onresize={this.onResizeMap}
      >
        {this.state.baselayerselected !== null ? (
          <WMSTileLayer
            ref={this.tileRef}
            layers={this.state.layers}
            // url='http://192.168.192.103:8080/geoserver/cite/wms'
            url={this.state.url}
            format="image/png"
            transparent={true}
            // crs={ crs}
            zIndex={1}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}
        {this.props.india_states_boundary !== null &&
          this.props.selected !== "Inflows into major reservoirs" ? (
            <Pane className="GridcellsPane">
              {" "}
              <GeoJSON
                ref="geojson"
                key={this.props.india_states_boundary.features[0].id}
                data={this.props.india_states_boundary}
                onEachFeature={this.highlightState}
              // crs={crs}
              // zIndex={10}
              // transparent={true}
              />{" "}
            </Pane>
          ) : null}

          
        {
          this.props.selected !== null && this.props.selected !== 'smai-weekly' && this.props.selected !== 'smai-monthly'
          ? (
            <WMSTileLayer
              url={`${domain.Geoserver}/nhp_vic/wms`}
              layers={
                "nhp_vic:" +
                layerMap[this.props.selected] +
                "_" +
                this.props.selectedLayer[this.props.selected]
              }
              format="image/png"
              zIndex={5}
              transparent={true}
              onloading={this.loading}
              onload={this.load}
            // opacity={1}
            // crs={ crs}
            />
          )
          : (this.props.selected === 'smai-weekly' || this.props.selected === 'smai-monthly') ? 
          (
            <WMSTileLayer
              url={`${domain.Geoserver}/nhp_vic/wms`}
              layers={
                "nhp_vic:" +
                this.props.selectedLayer[this.props.selected]
              }
              format="image/png"
              zIndex={5}
              transparent={true}
              onloading={this.loading}
              onload={this.load}
            // opacity={1}
            // crs={ crs}
            />
          )
          : null
        }

        {/* {this.props.selected !== null ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_vic/wms`}
            layers={
              "nhp_vic:" +
              layerMap[this.props.selected] +
              "_" +
              this.props.selectedLayer[this.props.selected]
            }
            format="image/png"
            zIndex={5}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
          // opacity={1}
          // crs={ crs}
          />
        ) : null} */}

        {this.props.reservoirjson !== null && reservoir_status === 1 && layerMap[this.props.selected]!=='SMAI'?

          <Pane className="GeoJSONPane">
            <GeoJSON
              ref="geojson"
              key={this.props.reservoirkey}
              data={this.props.reservoirjson}
              onEachFeature={this.onEachFeature}
              pointToLayer={this.pointToLayer}
            // crs={crs}
            // zIndex={10}
            // transparent={true}
            />
          </Pane>
          : null}

        {/* {
                        this.state.basininfo!==null && this.props.selected==='Inflows into major reservoirs'  ?
                        <GeoJSON 
                        ref="geojson" 
                        key={count1+1} 
                        data={this.state.basininfo}
                        onEachFeature={this.highlightBasin}
                        
                        // crs={crs}
                        // zIndex={10}
                        // transparent={true}
                    />:null
                    } */}

        {
          // this.props.stateInfo?
          //     <GeoJSON
          //         ref="geojson"
          //         key={this.props.stateInfo.key}
          //         data={this.props.stateInfo.geojson}
          //         onEachFeature={this.highlightState}
          //         crs={ crs}
          //     />
          // :null
        }

        {/* {
                            !this.state.markerenable? <Dialog ref={(ref) => { this.dialog = ref; }} id="dialog1" size={[300,200]} onClosed={this.handleMark} position="topleft" anchor={[250,250]}>
                                    <MinimalWindow info="Click any where inside india boundary" title="Information "  /> 
                            </Dialog>:null
                        } */}
        {this.props.popMenuSelected !== "Inflows into major reservoirs" &&
          this.props.latlng !== null ? (
            <Marker
              position={
                this.props.latlng.lat && this.props.latlng.lng
                  ? [this.props.latlng.lat, this.props.latlng.lng]
                  : [0, 0]
              }
            />
          ) : null}

        <Control position="topleft">
          <Popup
            trigger={


              <Button
                size="tiny"
                onClick={this.resetZoom}
                compact
                style={{ padding: "8px" }}
              >
                <FontAwesomeIcon icon="globe-asia" size="lg" />
              </Button>
            }
            position="right center"
          >
            <Popup.Content>Reset Zoom</Popup.Content>
          </Popup>
        </Control>

        {/* {this.props.reservoirjson !==null && this.props.popMenuSelected==='Inflows into major reservoirs'?    <Control position='topright'>
                    <Label as='a' color='green' ribbon size="large"> Click any reservoir point <br/> to know the current inflow and <br/>  3 days forecast inflow </Label> 
                    </Control>:null} */}
        <Control position="topleft">
          <div>
            {this.props.showInfo ? (
              <div
                style={{
                  marginRight: "0px",
                  paddingLeft: "0rem",
                  paddingRight: "0rem",
                  marginLeft: "0px",
                }}
              >
                <Button
                  basic
                  attached="right"
                  floated="right"
                  size="tiny"
                  compact
                  style={{ padding: "5px" }}
                  onClick={this.props.toggleShowInfo}
                  color={isNull(this.props.pointInfo) ? "brown" : "teal"}
                >
                  <FontAwesomeIcon icon="window-close" size="lg" />
                </Button>
                <Message
                  icon="map marker alternate"
                  info
                  warning={isNull(this.props.pointInfo)}
                  attached="bottom"
                >
                  <Icon name="map marker alternate" />
                  {this.props.pointInfo !== null ? (
                    <Message.Content>
                      <Message.Header>
                        {layerMap[this.props.selected].split("_")[0] === "FSRO"
                          ? "Forecast Surface Runoff"
                          : layerMap[this.props.selected] === "RO"
                            ? "Runoff"
                            : this.props.selected}
                      </Message.Header>
                      <b>Date:</b>&nbsp;
                      {layerMap[this.props.selected] === "FSRO_1" ? (
                        <b>{this.props.activeDate}</b>
                      ) : layerMap[this.props.selected] === "FSRO_2" ? (
                        <b>
                          {moment(this.props.activeDate, "DD MMM YYYY")
                            .add(1, "days")
                            .format("DD MMM YYYY")}
                        </b>
                      ) : layerMap[this.props.selected] === "FSRO_3" ? (
                        <b>
                          {moment(this.props.activeDate, "DD MMM YYYY")
                            .add(2, "days")
                            .format("DD MMM YYYY")}
                        </b>
                      ) : (
                              <b>{this.props.activeDate}</b>
                            )}
                      <br />{" "}
                      {isNull(this.props.pointInfo) ? (
                        <div>
                          <b>Data not available in this region</b>
                        </div>
                      ) : (
                          <div>
                            <b>Value:</b>&nbsp;{this.props.pointInfo} &nbsp;
                          {this.props.units_u}{" "}
                          </div>
                        )}
                      <b></b>
                      {/* <b>State:</b>&nbsp;{this.props.stateInfo.geojson.properties.STATE.toLowerCase().split(' ').map((word)=> word.replace(word[0], word[0].toUpperCase())).join(' ')} */}
                    </Message.Content>
                  ) : (
                      "Select a place within Indian boundary"
                    )}
                </Message>
              </div>
            ) : (
                <Popup
                  trigger={
                    <Button
                      size="tiny"
                      compact
                      style={{ padding: "8px" }}
                      onClick={this.props.toggleShowInfo}
                    >
                      <FontAwesomeIcon icon="info-circle" size="lg" />
                    </Button>
                  }
                  position="right center"
                >
                  <Popup.Content>
                    click this to know about what is in the point you clicked in
                    the map
                </Popup.Content>
                </Popup>
              )}
          </div>
        </Control>
        {this.state.layerloading ? (
          <Control position="topleft">
            <div style={style}>
              <FadeLoader
                height="15"
                radius="3"
                margin="3"
                width="10"
                // css={override}
                sizeUnit={"px"}
                // size={150}
                color={"#123abc"}
                loading={this.state.layerloading}
              />
            </div>
          </Control>
        ) : null}
        {this.props.datesloading ? (
          <Control position="topleft">
            <div style={style}>
              <FadeLoader
                height="15"
                radius="3"
                margin="3"
                width="10"
                // css={override}
                sizeUnit={"px"}
                // size={150}
                color={"#123abc"}
                loading={this.props.datesloading}
              />
            </div>
          </Control>
        ) : null}



        {window.innerWidth > 1000 ?
          <Control position="topleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control>
          : <Control position="bottomleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control>}

        <Control position="topright">
          <OffCanvas
            width={200}
            transitionDuration={300}
            effect={"overlay"}
            style={{ cursor: "move" }}
            isMenuOpened={this.state.isMenuOpened}
            position={"right"}
          >
            <OffCanvasMenu
              style={{
                alignContent: "center",
                backgroundColor: "rgb(255,255,255)",
                borderColor: "blue",
                top: "10px",
                marginRight: "10px",
              }}
            >
              <div>
                <div style={{ background: colors.final_side }}>
                  
                  <Menu.Item
                    as="div"
                    onClick={this.displayBaseLayers}
                    style={{ textAlign: "center", marginLeft: `5px` }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80%",
                          color: colors.textcolor,
                          fontSize: "small",
                          cursor: "default",
                        }}
                      >
                        Base Layers
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "20%",
                          marginRight: "10px",
                        }}
                      >
                        {this.state.baseLayers ? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                            <FontAwesomeIcon icon="angle-right" />
                          )}
                      </div>
                    </div>
                  </Menu.Item>
                </div>
                {this.state.baseLayers ? (
                  <div>
                    <input
                      type="radio"
                      name="baselayer"
                      value="Satellite"
                      checked={this.state.baselayerselected === "Satellite"}
                      onChange={this.changeBaseLayer}
                    />{" "}
                    Satellite <br />
                    <input
                      type="radio"
                      name="baselayer"
                      value="Map"
                      checked={this.state.baselayerselected === "Map"}
                      onChange={this.changeBaseLayer}
                    />{" "}
                    Map <br />
                    {/* <input
                      type="radio"
                      name="baselayer"
                      value="Basin"
                      checked={this.state.baselayerselected === "Basin"}
                      onChange={this.changeBaseLayer}
                    />{" "}
                    Basin */}
                  </div>
                ) : null}

                {this.props.selected !== "Inflows into major reservoirs" ? (
                  <div style={{ background: colors.final_side }}>
                    <Menu.Item
                      as="div"
                      onClick={this.props.displayLegend}
                      style={{ textAlign: "center", marginLeft: `5px` }}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            width: "80%",
                            color: colors.textcolor,
                            fontSize: "small",
                            cursor: "default",
                          }}
                        >
                          Legend
                        </div>
                        <div
                          style={{
                            textAlign: "right",
                            width: "20%",
                            marginRight: "10px",
                          }}
                        >
                          {this.props.legendVisible ? (
                            <FontAwesomeIcon icon="angle-down" />
                          ) : (
                              <FontAwesomeIcon icon="angle-right" />
                            )}
                        </div>
                      </div>
                    </Menu.Item>
                  </div>
                ) : null}

                {this.props.legendVisible && reservoir_status === 0 ? (
                  <React.Fragment>
                     {/* <center style={{  backgroundColor:colors.final_side_sub}}> */}
                     <center>
                      {title ? (
                        <p style={{ fontWeight: "700" }}>
                          {ReactHTMLParser(title)} {this.props.activeDate}
                        </p>
                      ) : null}

                      <img src={this.props.legend} alt="" />

                    </center>
                  </React.Fragment>
                ) : null}

                 {this.props.legendVisible && layerMap[this.props.selected]==='SMAI' ? (
                  <React.Fragment>
                    <center style={{ overflowY: "auto", maxHeight:"300px" }}>
                      {title ? (
                        <p style={{ fontWeight: "700" }}>
                          {ReactHTMLParser(title)} 
                        </p>
                      ) : null}

                      <img src={this.props.legend} alt="" />

                      {this.props.selected === 'smai-weekly' ? (
                        <p>
                          {ReactHTMLParser(this.state.smai_leg)} 
                        </p>
                      ) : null}

                

                    </center>
                  </React.Fragment>
                ) : null}
                {/* <div style={{background:colors.final_side}}>
               
            
               <Menu.Item as='div'  onClick={this.props.r_chartdata!==null?this.props.toggleVisibleGraphPanel_pie:null} style={{textAlign:"center", marginLeft:`5px`}}>
        
               <div style={{display:"flex"}}>
                                <div style={{width:"80%",color:"white",fontSize:"medium",cursor:"default"}}>Graph</div>
                                <div style={{textAlign:"right", width:"20%",marginRight:"10px"}}>
                                {
                                    (this.props.visibleGraphPanel_pie) && this.props.r_chartdata!==null?
                                    (
                                        
                                        <FontAwesomeIcon icon="angle-down" />
                                        
                                    ):
                                    (
                                        
                                        <FontAwesomeIcon icon="angle-right" />
                                        
                                    )
        
                                }
                                
                        
                                </div>
        
                            </div>
                            </Menu.Item>
             
                            </div>
                       
        
        
                                         {this.props.visibleGraphPanel_pie && this.props.reservoirname!==null?
                                         
                                                     
                                       
                                            <GradientChart rname={this.props.reservoirname} data={this.props.r_chartdata}  />
                                                             
                                                                :null}
                                                              
                                                              
                                         */}
              </div>
            </OffCanvasMenu>
          </OffCanvas>
        </Control>
        {/* <Control position="topright" >
          <div   >
            {
              platformItems.map((item, index) => {
                var itemClassName = 'toolbar-item ' + item.className


                return (
                  <div
                    data-id={item.name}
                    key={index}
                    className={itemClassName}
                    onClick={() => this.handleClick_tools(item.name)
                    }

                  >

                    
                  </div>
                )
              })
            }
          </div>
        </Control> */}
        {!this.props.visibleGraphPanel &&
         ( this.props.chartData || this.props.r_chartdata !== null) ? (
            <Control position="bottomright">
              <Popup
                trigger={
                  <Button
                    onClick={this.props.toggleVisibleGraphPanel}
                    secondary
                    style={{ backgroundColor:colors.graphical  }}
                    compact
                    size="medium"
                  >
                    <FontAwesomeIcon icon="chart-bar" size="lg" />
                  </Button>
                }
                position="left center"
              >
                <Popup.Content>Graphical Analysis</Popup.Content>
              </Popup>
            </Control>
          ) : null}

        <Control
          position="bottomleft"
          style={{ pointerEvents: "auto", cursor: "auto" }}
        >
          {reservoir_status === 0 ? (
            <DateSlider {...this.props.sliderOptions} />
          ) : null}
        </Control>
        <MouseControl position="bottomleft" />
        <ScaleControl metric={true} />

        {/* {this.state.popup.position ?
                        <ReactPopup 
                            key={`popup-${this.state.popup.key_p}`}
                            position={this.state.popup.position} className="request-popup"
                            >
                            
                                
                            <GradientChart rname={this.state.popup.reservoirname} data={this.state.popup.chartData}  />
                          
                        </ReactPopup>:null
                        } */}
      </Map>
    );
  }
}

export default MapView;
